module.exports = __webpack_public_path__ + "img/favorites (1).7d2e55f4.svg";